import { Atmosphere } from '../layers/Atmosphere.js';
import { SpiralStaircase } from '../layers/SpiralStaircase.js';
import { Shaft } from '../layers/Shaft.js';
import { DreamCity } from '../layers/DreamCity.js';
import { Seashells } from '../layers/Seashells.js';
import { Telescopes } from '../layers/Telescopes.js';
import { Violins } from '../layers/Violins.js';
import { Elders } from '../layers/Elders.js';
import { MemoryWake } from '../layers/MemoryWake.js';

/**
 * The city, listed.
 *
 * This is the only place that knows what Isidora is made of. Each entry owns
 * one motif from the text; they are built and ticked in `order`, and they
 * never reference one another. To add something Calvino mentions and we have
 * not drawn — the cockfights, the foreigner and the third woman — write a
 * `Layer` subclass and add it here.
 */
export const LAYERS = [
  Atmosphere, //   0 · the hour, the fog, the stars, the dust
  SpiralStaircase, // 10 · the stair itself
  Shaft, //         20 · the building around it
  DreamCity, //     30 · what is outside the windows
  Seashells, //     40 · the encrustation
  Telescopes, //    50 · the instruments that look out
  Violins, //       55 · the instruments that are listened to
  Elders, //        60 · the wall at the foot, and the youth going by
  MemoryWake, //    70 · everything that has been wanted
];

export function sortedLayers(list = LAYERS) {
  return [...list].sort((a, b) => (a.order ?? 100) - (b.order ?? 100));
}
